export const ORG_NAME = "CitizenShipper"
export const ORG_URL = "https://citizenshipper.com"

/** Shared Organization fragment for schema factories. */
export const citizenShipperOrganization = {
  "@type": "Organization",
  name: ORG_NAME,
  url: ORG_URL,
}

/**
 * Serializes a schema object for a JSON-LD <script> tag. Escapes "<" so no
 * string value (e.g. HTML-bearing FAQ answers or API-sourced review text) can
 * ever close the script tag early.
 */
export const toJsonLdString = (schema: unknown): string => {
  const serialized = JSON.stringify(schema)

  if (serialized === undefined) {
    throw new TypeError("JSON-LD input must be JSON-serializable")
  }

  return serialized.replace(/</g, "\\u003c")
}

/**
 * Serializes a single value as a quoted JSON string literal, for schemas built
 * as template literals rather than objects. Callers interpolate it in place of
 * the quotes — `"name": ${toJsonLdValue(city)}` — so a value carrying a quote,
 * backslash or control character cannot invalidate the block.
 */
export const toJsonLdValue = (value: string): string =>
  JSON.stringify(value).replace(/</g, "\\u003c")
